/**
 * DraftManagementPage - Workflow draft management
 *
 * Surfaces the DraftManager from @ferp/workflow-forms for admin/architect users.
 * Provides management of draft workflows, version history, and conflict resolution.
 *
 * Route: /admin/drafts
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconFileText } from '@tabler/icons-react';

import { DraftManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function DraftManagementPage() {
  const { tenant, user } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="orange">
            <IconFileText size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Draft Management</Title>
            <Text size="sm" c="dimmed">
              Manage workflow drafts, version history, and resolve conflicts
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <DraftManager kind="workflow" userId={user?.id ?? 'anonymous'} />
    </Container>
  );
}

export default DraftManagementPage;
